import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AddPostForm from "../pages/posts/AddPostForm";
import Home from "../pages/Home";
import Bio from "../pages/Bio";
import Contatti from "../pages/Contatti";
import { GetRouteByName } from "./Routes";
import Servizi from "../pages/Servizi";

function AppMainBodyRoutes() {
  return (
    <Routes>
      <Route path="/redirect-page" element={<Navigate to="/error-page" />} />
      <Route path={GetRouteByName("Home")} element={<Home />} />
      <Route path={GetRouteByName("Bio")} element={<Bio />} />
      <Route path={GetRouteByName("Servizi")} element={<Servizi />} />
      <Route path={GetRouteByName("Contatti")} element={<Contatti />} />
      <Route path="/addpost" element={<AddPostForm />} />
    </Routes>
  );
}

export default AppMainBodyRoutes;
